import { useScope } from '@/hooks/useScope';

/**
 * Returns a guaranteed hospitalId from Scope.
 * - Throws if used outside of ScopeProvider (enforced by useScope).
 * - Throws if scope.hospital.id is nullish.
 */
export const useScopeHospitalId = (): string => {
  const scope = useScope();
  const id = scope?.hospital?.id as string | number | undefined | null;

  if (id == null || id === '') {
    throw new Error(
      'useScopeHospitalId must be used with an initialized Scope. Expected scope.hospital.id to be present.'
    );
  }

  return String(id);
};
